module.exports = __webpack_public_path__ + "static/media/3-F.1da9f3f4.webp";